import type { BestPrice } from '@/graphql/gql-types';

export default (bestPrice: BestPrice) =>
  bestPrice?.surcharges?.find((charge) => charge?.code === 'ZECO');
